<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div [hidden]="pgLoad">
      <div class="adjust loader-container">
        <div class="loader2"></div>
      </div>
    </div>
    <div class="page-breadcrumb">
      <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Business</a></li>
          <li><a>Business Entities</a></li>
        </ul>
      <div class="page-breadcrumb__icons">
        <a routerLink="/home"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
      </div>
    </div>
    <div class="block" [hidden]="!pgLoad">
      <div class="screen_heading_div">
        <span>Businesses</span>
        <img src="assets/images/New_Icons/refresh.svg"  title="Refresh"
             (click)="ngOnInit()">
      </div>
      <div class="search_cum_icons_button_container">
        <div class="search-div">
          <img src="../../../../../../../assets/images/New_Icons/search-icon.svg">
          <input type="text" (keyup)="searchBusiness()" [(ngModel)]="search" name="search" autocomplete="off"
                 placeholder="Search by business, mobile number, email etc..">
        </div>
        <div class="add-button-container" (click)="openForm()">
          <button class="button">
            <span class="icon"><img src="../../../../../../../assets/images/New_Icons/plus-icon.svg"></span>
            <span class="text">Add New</span>
          </button>
        </div>
      </div>
      <div class="row">
        <div [hidden]="loader">
          <div class="adjust loader-container">
            <div class="loader2"></div>
          </div>
        </div>
        <div class="businessCardsData" id="style-4" style="height: 640px; cursor: pointer" [hidden]="!loader">
          <div *ngIf="filteredBusinessessArray && filteredBusinessessArray.length > 0">
            <div *ngFor="let eachFilteredArray of filteredBusinessessArray;let i = index">
              <div class="row businessheading" *ngIf="eachFilteredArray && eachFilteredArray.length > 0">
                <p class="col-xs-11">{{eachFilteredArray[0].businessType[0].name}}</p>
                <p class="col-xs-1">{{eachFilteredArray.length}}</p>
              </div>
              <div class="row businessheading" *ngIf="eachFilteredArray && eachFilteredArray.length == 0">
                <p class="col-xs-11">{{businessTypesFiltered[i].name}}</p>
                <p class="col-xs-1">0</p>
              </div>
              <hr *ngIf="eachFilteredArray && eachFilteredArray.length >= 0">
              <div class="cards_container">
                <div class="card_wrapper searchfun"
                     *ngFor="let eachaactivedocdata of eachFilteredArray">
                  <div class="each_card_div">
                    <div class="card_content">
                      <div class="card_header">
                        <div class="img_cum_business_name_div">
                          <img src="../../../../../../../assets/images/New_Icons/card-heading.svg">
                          <span *ngIf="(eachaactivedocdata.businessType[0].name)=='Farm'"
                                routerLink="/home/BusinessEntityFarms/{{eachaactivedocdata.id}}/{{paramBusiness}}"
                                class="farm_name">
                            {{eachaactivedocdata && eachaactivedocdata.businessName}}</span>
                          <span
                            *ngIf="(eachaactivedocdata.businessType[0].name) !='Farm'"
                            class="farm_name">
                            {{eachaactivedocdata && eachaactivedocdata.businessName}}</span>
                        </div>
                      </div>
                      <div class="card_body">
                        <div>
                          <img src="../../../../../../../assets/images/New_Icons/phone-card-icon.svg">
                          <span>{{eachaactivedocdata.dialingCode}} {{(eachaactivedocdata && eachaactivedocdata.mobileNumber == '' || eachaactivedocdata && eachaactivedocdata.mobileNumber == null) ? 'NA' : eachaactivedocdata && eachaactivedocdata.mobileNumber}}</span>
                        </div>
                        <div>
                          <img src="../../../../../../../assets/images/New_Icons/email-card-icon.svg">
                          <span>{{(eachaactivedocdata && eachaactivedocdata.email == '' || eachaactivedocdata && eachaactivedocdata.email == null) ? 'NA' : eachaactivedocdata && eachaactivedocdata.email}}</span>
                        </div>
                        <div>
                          <img src="../../../../../../../assets/images/New_Icons/address-card-icon.svg">
                          <span
                            class="description">{{(eachaactivedocdata && eachaactivedocdata.address.length > 0 ? (((eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].pincode) && (eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].district)) ? ((eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].pincode) + ', ' + (eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].district)) : (((eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].pincode) && !(eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].district)) ? (eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].pincode) : (!(eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].pincode) && (eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].district)) ? (eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].district) : '')) : 'NA') || 'NA'}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="card_footer">
                      <div class="separate_field" (click)="navigateToAccountClosureScreen(eachaactivedocdata.id)">
                        <div *ngIf="eachaactivedocdata.status != 'trial'">
                          <span *ngIf="eachaactivedocdata.accountStatus == 'markedForInactivation'" style="color: red;cursor: pointer;">Closure request</span>
                          <span *ngIf="eachaactivedocdata.accountStatus == 'inactivated'" style="color: red;cursor: pointer;">Ready for closure</span>
                          <span *ngIf="eachaactivedocdata.accountStatus == 'active'" style="color: green;font-weight: bold;cursor: pointer;">Active</span>
                          <span *ngIf="eachaactivedocdata.accountStatus == 'cancelRequested'" style="color: red;cursor: pointer;">Cancel request</span>
                          <span *ngIf="eachaactivedocdata.accountStatus == 'closed'" style="color: red;font-weight: bold;cursor: pointer;">Closed</span>
                        </div>
                      </div>
                      <div class="activities_icons">
                        <a *ngIf="eachaactivedocdata.status != 'trial'">
                          <img class="activities_images" style="padding: 10px 11px;" src="../../../../../../../assets/images/New_Icons/delete-icon.svg" routerLink="/home/account-closure/businessID/{{eachaactivedocdata.id}}" title="To close account">
                        </a>
                        <a>
                          <img class="activities_images" src="../../../../../../../assets/images/New_Icons/edit.svg" style="padding: 2px"  title="Edit Business" (click)="getBusinessEntityById(eachaactivedocdata.id)">
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row row-flex notfoundtext" *ngIf="eachFilteredArray && eachFilteredArray.length == 0">No
                businessess Found
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dynamic-form-wrapper"
          [ngClass]="{
            'floating-panel': formFieldCount <= 7,
            'slide-in-overlay': formFieldCount > 7
          }"
          *ngIf="showForm">


        <div class="popup-wrapper">

          <button type="button" class="popup-close-beside" (click)="closeForm()" title="Close">
            &times;
          </button>

          <!-- Actual Popup -->
          <div [ngClass]="{
              'form-container-panel': formFieldCount > 7,
              'popup-inner': formFieldCount <= 7
            }">

            <form [formGroup]="registerForm">
              <div class="form-header">
                <div class="form-title">Business</div>
                <button class="add-update-submit-button" (click)="submitButton ? addToCustomerLead() : farmProviderUpdate()" [disabled]="businessCreationDoubleClick">
                  <span class="icon"><img src="../../../../assets/images/New_Icons/tick-icon.svg"></span>
                  <span class="text">{{ submitButton ? 'Submit' : 'Update'}}</span>
                </button>
              </div>

              <div class="form-container">

                <!-- ───────── Info Banner (kept as‑is) ───────── -->
                <div
                  class="businessCode_info_css"
                  *ngIf="businessEntity.businessCode"
                >
                  <img
                    src="../../../../assets/images/New_Icons/info-icon.svg"
                    height="20"
                    width="20"
                  />
                  <span>
                    Unique ID will be used to uniquely identify your business and products
                    (Seed) for your potential consumers
                  </span>
                </div>

                <!-- === Section: Business Information === -->
                <div class="form-section">
                  <div class="grid-three-cols">

                    <!-- ───────── BUSINESS NAME ───────── -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Business Name</mat-label>
                      <input
                        matInput
                        id="businessName"
                        autocomplete="off"
                        formControlName="businessName"
                        [(ngModel)]="businessEntity.businessName"
                        (input)="onBusinessChange()"
                        (keyup)="getBusinessCode()"
                      />

                      <mat-hint>
                        <i>5-30 alaphabetic characters</i>
                      </mat-hint>

                      <!-- Validation -->
                      <mat-error *ngIf="(submitted || f.businessName.touched || f.businessName.dirty) && f.businessName.errors">
                        <ng-container *ngIf="f.businessName.hasError('required')">Business name is <i>required</i>.</ng-container>
                        <ng-container *ngIf="f.businessName.hasError('minlength')">Must be <i>at least 5 characters</i>.</ng-container>
                        <ng-container *ngIf="f.businessName.hasError('maxlength')">Cannot exceed <i>30 characters</i>.</ng-container>
                        <ng-container *ngIf="f.businessName.hasError('pattern')">No numbers or special characters allowed.</ng-container>
                      </mat-error>
                    </mat-form-field>

                    <!-- ───────── BUSINESS CODE (readonly) ───────── -->
                    <mat-form-field
                      *ngIf="businessEntity.businessCode"
                      appearance="outline"
                      class="w-100 disbledCls"
                    >
                      <mat-label>Your unique ID</mat-label>
                      <input
                        matInput
                        id="businessCode"
                        readonly
                        formControlName="businessCode"
                        [(ngModel)]="businessEntity.businessCode"
                      />
                    </mat-form-field>

                    <!-- ───────── BUSINESS CATEGORY ───────── -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Business Category</mat-label>
                      <mat-select
                        formControlName="category"
                        [(ngModel)]="businessCategory.businessCategoryID"
                        (selectionChange)="getBusinessTypes(businessCategory.businessCategoryID)"
                      >
                        <mat-option value="undefined" disabled>Select Business Category</mat-option>
                        <mat-option *ngFor="let cat of businessCategories" [value]="cat.id">
                          {{ cat.name }}
                        </mat-option>
                      </mat-select>

                      <mat-hint *ngIf="f.category.invalid">
                        <i>Select business category</i>
                      </mat-hint>
                      <mat-hint *ngIf="f.category.valid">
                        <i>Business category selected</i>
                      </mat-hint>

                      <mat-error
                        *ngIf="(submitted || f.category.touched || f.category.dirty) && f.category.hasError('required')"
                      >
                        Business category is <i>required</i>.
                      </mat-error>
                    </mat-form-field>

                    <!-- ───────── BUSINESS TYPE ───────── -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Business Type</mat-label>
                      <mat-select
                        id="businessType"
                        formControlName="businessType"
                        [(ngModel)]="businessType.businessTypeID"
                      >
                        <mat-option value="undefined" disabled>Select Business Type</mat-option>
                        <mat-option *ngFor="let type of businessTypes" [value]="type.id">
                          {{ type.name }}
                        </mat-option>
                      </mat-select>

                       <mat-hint *ngIf="f.businessType.invalid">
                        <i>Select business type</i>
                      </mat-hint>
                      <mat-hint *ngIf="f.businessType.valid">
                        <i>Business type selected</i>
                      </mat-hint>

                      <mat-error
                        *ngIf="(submitted || f.businessType.touched || f.businessType.dirty) && f.businessType.hasError('required')"
                      >
                        Business type is <i>required</i>.
                      </mat-error>
                    </mat-form-field>

                    <!-- ───────── CULTURE CATEGORY ───────── -->
                    <!-- <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Farm buddy</mat-label>
                      <mat-select
                        id="farmBuddy"
                        formControlName="personId"
                        [(ngModel)]="personId"
                        (selectionChange)="onFarmBuddyChange(personId)"
                      >
                        <mat-option value="undefined" disabled>Select Person</mat-option>
                        <mat-option value="none">None</mat-option>
                        <mat-option *ngFor="let person of persons" [value]="person.id">
                          {{person.firstName}} {{person.lastName}}
                        </mat-option>
                      </mat-select>

                       <mat-hint *ngIf="f.personId.invalid">
                        <i>Select person</i>
                      </mat-hint>
                      <mat-hint *ngIf="f.personId.valid">
                        <i>Person selected</i>
                      </mat-hint>

                      <mat-error
                        *ngIf="(submitted || f.personId.touched || f.personId.dirty) && f.personId.hasError('required')"
                      >
                        Person is <i>required</i>.
                      </mat-error>
                    </mat-form-field> -->
                  </div>
                </div>

                <!-- === Section: Location Details === -->
                <div class="form-section">
                  <h3 class="section-title">Location Details</h3>
                  <div class="grid-three-cols">

                    <!-- ───────── COUNTRY (autocomplete) ───────── -->
                    <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Country Selection</mat-label>
                  <input
                    matInput
                    id="country"
                    autocomplete="off"
                    formControlName="countryName"
                    [matAutocomplete]="autoCountry"
                    (focus)="filteredCountriesList=countries"
                    (keyup)="filterCountries()"
                  />

                  <mat-autocomplete #autoCountry="matAutocomplete" (optionSelected)="coutrySelection($event.option.value)">
                    <mat-option *ngFor="let c of filteredCountriesList" [value]="c">
                      {{ c.name }}
                    </mat-option>
                  </mat-autocomplete>

                  <mat-hint *ngIf="f.countryName.invalid">
                    <i>Select country</i>
                  </mat-hint>
                  <mat-hint *ngIf="f.countryName.valid">
                    <i>Country selected</i>
                  </mat-hint>

                  <mat-error *ngIf="(submitted || f.countryName.touched || f.countryName.dirty) && f.countryName.hasError('required')">
                    Required.
                  </mat-error>
                    </mat-form-field>

                    <!-- ───────── DIAL CODE (readonly) ───────── -->
                    <mat-form-field appearance="outline" class="w-100 dialcode-farm-element">
                      <mat-label>Dial Code</mat-label>
                      <input
                        matInput
                        id="dialCode"
                        readonly
                        formControlName="dialCode"
                        [(ngModel)]="businessEntity.dialingCode"
                      />
                    </mat-form-field>

                    <!-- ───────── STATE ───────── -->
                    <mat-form-field
                      appearance="outline"
                      class="w-100"
                      [ngClass]="{ disbledCls: stateVillageDisabled }"
                    >
                      <mat-label>State Selection</mat-label>
                      <input
                        matInput
                        id="state"
                        autocomplete="off"
                        formControlName="stateName"
                        [matAutocomplete]="autoState"
                        [disabled]="stateVillageDisabled"
                        (focus)="filteredStatesList=states"
                        (keyup)="filterStates()"
                      />

                      <mat-autocomplete
                        #autoState="matAutocomplete"
                        (optionSelected)="stateSelection($event.option.value)"
                      >
                        <mat-option *ngFor="let s of filteredStatesList" [value]="s">
                          {{ s.name }}
                        </mat-option>
                      </mat-autocomplete>

                      <mat-hint *ngIf="f.stateName.invalid">
                        <i>Select state</i>
                      </mat-hint>
                      <mat-hint *ngIf="f.stateName.valid">
                        <i>State selected</i>
                      </mat-hint>

                      <mat-error *ngIf="(submitted || f.stateName.touched || f.stateName.dirty) && f.stateName.hasError('required')">
                        Required.
                      </mat-error>
                    </mat-form-field>

                    <!-- ───────── VILLAGE ───────── -->
                    <mat-form-field appearance="outline" class="w-100" [ngClass]="{ disbledCls: stateVillageDisabled }">
                  <mat-label>Village Selection</mat-label>

                  <input
                    matInput
                    id="village"
                    autocomplete="off"
                    formControlName="villageName"
                    [matAutocomplete]="autoVillage"
                    [disabled]="stateVillageDisabled || isLoadingVillages"
                    (keyup)="filterVillages($event)"
                    (focus)="onVillageFocus()"
                    (blur)="onVillageBlur()"
                    #autoTrigger="matAutocompleteTrigger"
                  />

                  <!-- Loader while fetching API -->
                  <mat-spinner *ngIf="isLoadingVillages" diameter="20" class="absolute right-2 top-2"></mat-spinner>

                  <mat-autocomplete #autoVillage="matAutocomplete" panelClass="village-panel">
                    <!-- Error message if API fails -->
                    <mat-option *ngIf="villagesLoadError" disabled>
                      Villages fetching failed. Reselect state to retry.
                    </mat-option>

                    <!-- No data found message -->
                    <mat-option *ngIf="noDataFound" disabled>
                      No data found
                    </mat-option>

                    <!-- Virtual Scroll Container -->
                    <cdk-virtual-scroll-viewport itemSize="48" style="height: 250px;" 
                      [style.height.px]="visibleVillages.length < CHUNK_SIZE ? visibleVillages.length * 48 : 250"
                      (scrolledIndexChange)="onVillageScroll()"
                      [minBufferPx]="500"
                      [maxBufferPx]="1000">
                      <div *cdkVirtualFor="let v of visibleVillages; let i = index">
                        <mat-option [value]="v.city_town_village_name" (click)="villageSelection(v)">
                          {{ v.city_town_village_name }}
                        </mat-option>
                      </div>

                      <!-- Loader inside scroll -->
                      <div class="loader-section" *ngIf="isLoadingMore">
                        <mat-spinner diameter="20"></mat-spinner>
                        <span>Loading more...</span>
                      </div>
                    </cdk-virtual-scroll-viewport>
                  </mat-autocomplete>

                  <mat-hint *ngIf="f.villageName.invalid"><i>Select village</i></mat-hint>
                  <mat-hint *ngIf="f.villageName.valid"><i>Village selected</i></mat-hint>

                  <mat-error *ngIf="(submitted || f.villageName.touched || f.villageName.dirty) && f.villageName.hasError('required')">
                    Required.
                  </mat-error>
              </mat-form-field>

                    <!-- ───────── PINCODE ───────── -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Pincode</mat-label>
                      <input
                        matInput
                        id="pincode"
                        formControlName="inputpincode"
                        autocomplete="off"
                        [(ngModel)]="address.pincode"
                      />
                      <mat-error
                        *ngIf="(submitted || f.inputpincode.touched || f.inputpincode.dirty) && f.inputpincode.errors"
                      >
                        <ng-container *ngIf="f.inputpincode.hasError('required')">Pincode is <i>required</i>.</ng-container>
                        <ng-container *ngIf="f.inputpincode.hasError('pattern')">Invalid <i>pincode</i>.</ng-container>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <!-- === Section: Contact Details === -->
                <div class="form-section">
                  <h3 class="section-title">Contact Details</h3>
                  <div class="grid-three-cols">

                    <!-- Email -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Email ID</mat-label>
                      <input
                        matInput
                        id="email"
                        autocomplete="off"
                        formControlName="email"
                        [(ngModel)]="businessEntity.email"
                      />
                      <mat-error *ngIf="(submitted || f.email.touched || f.email.dirty) && f.email.errors">
                        <ng-container *ngIf="f.email.hasError('pattern')">Must be a <i>valid email</i>.</ng-container>
                      </mat-error>
                    </mat-form-field>

                    <!-- Mobile -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Mobile Number</mat-label>
                      <input
                        matInput
                        id="mobileNumber"
                        autocomplete="off"
                        formControlName="mobilenumber"
                        [(ngModel)]="businessEntity.mobileNumber"
                      />
                      <mat-error *ngIf="(submitted || f.mobilenumber.touched || f.mobilenumber.dirty) && f.mobilenumber.errors">
                        <ng-container *ngIf="f.mobilenumber.hasError('required')">Mobile number is <i>required</i>.</ng-container>
                        <ng-container *ngIf="f.mobilenumber.hasError('pattern')">Enter a <i>valid mobile number</i>.</ng-container>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <!-- === Section: Address === -->
                <div class="form-section">
                  <h3 class="section-title">Address Details</h3>
                  <div class="grid-three-cols">

                    <!-- House / Door No -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>House/Flat/Door No</mat-label>
                      <input
                        matInput
                        id="address1"
                        autocomplete="off"
                        formControlName="inputhouseNo"
                        [(ngModel)]="address.houseNo"
                      />

                      <mat-hint>
                        <i>3-30 alaphabetic characters</i>
                      </mat-hint>

                      <mat-error *ngIf="(submitted || f.inputhouseNo.touched || f.inputhouseNo.dirty) && f.inputhouseNo.errors">
                        <ng-container *ngIf="f.inputhouseNo.hasError('minlength')">Minimum 3 characters required.</ng-container>
                        <ng-container *ngIf="f.inputhouseNo.hasError('maxlength')">Maximum 30 characters allowed.</ng-container>
                        <ng-container *ngIf="f.inputhouseNo.hasError('pattern')">Avoid <i>invalid special characters</i>.</ng-container>
                      </mat-error>
                    </mat-form-field>

                    <!-- Street -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Street</mat-label>
                      <input
                        matInput
                        id="address2"
                        autocomplete="off"
                        formControlName="inputstreet"
                        [(ngModel)]="address.street"
                      />

                      <mat-hint>
                        <i>3-30 alaphabetic characters</i>
                      </mat-hint>

                      <mat-error *ngIf="(submitted || f.inputstreet.touched || f.inputstreet.dirty) && f.inputstreet.errors">
                        <ng-container *ngIf="f.inputstreet.hasError('minlength')">Minimum 3 characters required.</ng-container>
                        <ng-container *ngIf="f.inputstreet.hasError('maxlength')">Maximum 30 characters allowed.</ng-container>
                        <ng-container *ngIf="f.inputstreet.hasError('pattern')">Numbers are <i>not allowed</i>.</ng-container>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <!-- === Section: Government IDs === -->
                <div class="form-section">
                  <h3 class="section-title">Government IDs</h3>
                  <div class="grid-three-cols">

                    <!-- CAA ID -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Enter CAA ID</mat-label>
                      <input
                        matInput
                        id="caaid"
                        autocomplete="off"
                        formControlName="caaid"
                        [(ngModel)]="businessEntity.CAA_ID"
                      />

                      <mat-hint><i>Max 16 chars</i></mat-hint>

                      <mat-error *ngIf="(submitted || f.caaid.touched || f.caaid.dirty) && f.caaid.errors">
                        <ng-container *ngIf="f.caaid.hasError('maxlength')">Maximum 16 characters allowed.</ng-container>
                      </mat-error>
                    </mat-form-field>

                    <!-- MPEDA ID -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Enter MPEDA ID</mat-label>
                      <input
                        matInput
                        id="mpedaid"
                        autocomplete="off"
                        formControlName="mpedaid"
                        [(ngModel)]="businessEntity.MPEDA_ID"
                      />

                      <mat-hint>
                        <i>Max 16 chars</i>
                      </mat-hint>

                      <mat-error *ngIf="(submitted || f.mpedaid.touched || f.mpedaid.dirty) && f.mpedaid.errors">
                        <ng-container *ngIf="f.mpedaid.hasError('maxlength')">Maximum 16 characters allowed.</ng-container>
                      </mat-error>
                    </mat-form-field>

                    <!-- Valid Through -->
                    <mat-form-field appearance="outline" class="w-100" formGroupName="validityField">
                      <mat-label>License Validity Period</mat-label>
                      <mat-date-range-input [rangePicker]="picker" [max]="maxDate"
                                (focus)="picker.open()" (click)="picker.open()">
                        <input matStartDate placeholder="Start date" formControlName="start" readonly />
                        <input matEndDate placeholder="End date" formControlName="end" readonly />
                      </mat-date-range-input>
                      <button mat-icon-button type="button" tabindex="-1" [ngStyle]="{ 'z-index': 1000, 'position': 'relative', 'background': 'none', 'border': 'none', 'box-shadow': 'none', 'outline': 'none'}" matSuffix (click)="picker.open()" aria-label="Toggle date">
                        <mat-icon>calendar_today</mat-icon>
                      </button>
                      <mat-date-range-picker #picker (closed)="onPickerClosed()"></mat-date-range-picker>
                    </mat-form-field>
                  </div>
                </div>

                <!-- === Section: Logo Upload === -->
                <div class="form-section">
                  <h3 class="section-title">Logo</h3>

                  <div class="grid-three-cols modern-upload-grid">
                    <!-- Upload Card -->
                    <div class="file-upload-area" (click)="fileInput.click()">
                      <input
                        type="file"
                        #fileInput
                        hidden
                        accept="image/jpeg, image/jpg, image/png, image/webp"
                        (change)="fileupload($event)"
                        style="display: none;"
                      />
                      <div class="upload-icon">
                        <img src="../../../../assets/images/New_Icons/upload-square-svgrepo-com.svg" width="28" height="28" />
                      </div>
                      <div class="upload-text">
                        <p class="upload-title">Click to Upload</p>
                        <p class="upload-subtitle">Accepted: JPG, JPEG, PNG, WEBP</p>
                      </div>
                    </div>

                    <!-- Preview -->
                    <div class="uploaded-preview" *ngIf="selectedbase64file">
                      <img [src]="selectedbase64file" alt="Uploaded Image" />
                      <button
                        type="button"
                        class="remove-btn"
                        (click)="remove()"
                        title="Remove"
                      >
                        ✕
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
  </div>
</div>
